module.exports = __webpack_public_path__ + "static/img/werner-logo-hell-no-subtitle.ad3fdbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/werner-logo-hell-no-subtitle.svg
// module id = e115
// module chunks = 1